exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1swMcnTK3b2wixfFzY04-f{height:1px}html[dir] ._1swMcnTK3b2wixfFzY04-f{background:var(--neutralLighterAlt)}", ""]);
// Exports
exports.locals = {
	"bottomBorder": "_1swMcnTK3b2wixfFzY04-f"
};